import React from "react";
import TextInput from "../../../common/TextInput";
import AutoComplete from "../../../common/AutoComplete";
import Row from "../../../common/Row";
import PropTypes from "prop-types";

const PlaatsPostcodeComponent = props => {
	const {
		model,
		isInBelgie,
		postcodeField,
		gemeenteField,
		postcodeNoBEField,
		gemeenteNoBEField,
		postcodes,
		gemeenten,
		disabled,
		onChange,
		getError,
		validationMessageType,
		disableGemeente
	} = props;

	const compBE = (
		<Row>
			<AutoComplete
				name={postcodeField}
				label="Postcode"
				size={3}
				items={postcodes}
				onChange={onChange}
				disabled={disabled}
				value={model[postcodeField]}
				validationMessage={getError(postcodeField)}
				validationMessageType={validationMessageType}
			/>
			<AutoComplete
				name={gemeenteField}
				label="Gemeente"
				size={9}
				items={gemeenten}
				onChange={onChange}
				disabled={disabled || disableGemeente}
				value={model[gemeenteField]}
				validationMessage={getError(gemeenteField)}
				validationMessageType={validationMessageType}
			/>
		</Row>
	);

	const compNoBE = (
		<Row>
			<TextInput
				name={postcodeNoBEField}
				label="Postcode"
				size={3}
				value={model[postcodeNoBEField]}
				onChange={onChange}
				validationMessage={getError(postcodeNoBEField)}
				validationMessageType={validationMessageType}
				disabled={disabled}
			/>
			<TextInput
				name={gemeenteNoBEField}
				label="Gemeente"
				size={9}
				value={model[gemeenteNoBEField]}
				onChange={onChange}
				validationMessage={getError(gemeenteNoBEField)}
				validationMessageType={validationMessageType}
				disabled={disabled || disableGemeente}
			/>
		</Row>
	);

	return isInBelgie ? compBE : compNoBE;
};

PlaatsPostcodeComponent.propTypes = {
	model: PropTypes.object.isRequired,
	isInBelgie: PropTypes.bool,
	disabled: PropTypes.bool,
	postcodeField: PropTypes.string.isRequired,
	gemeenteField: PropTypes.string.isRequired,
	postcodeNoBEField: PropTypes.string.isRequired,
	gemeenteNoBEField: PropTypes.string.isRequired,
	postcodes: PropTypes.array.isRequired,
	gemeenten: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	getError: PropTypes.func.isRequired,
	validationMessageType: PropTypes.string,
	disableGemeente: PropTypes.bool
};

export default PlaatsPostcodeComponent;
